export enum EdsFilterType {
  Input = 'INPUT',
  InputNumber = 'INPUT_NUMBER',
  InputNumberRange = 'NUMBER_RANGE',
  Select = 'SELECT',
  MultiSelect = 'MULTI_SELECT',
  Datepicker = 'DATEPICKER',
  DateRange = 'DATE_RANGE',
  Checkbox = 'CHECKBOX',
  MultiCheckbox = 'MULTI_CHECKBOX',
  Assignee = 'ASSIGNEE',
  HelperTag = 'HELPER_TAG',
}

export enum EdsFilterUrlParameter {
  TypeId = 'RelatedEntityType',
  ClaimSetId = 'RelatedEntityKey_ClaimSet',
  ClaimId = 'RelatedEntityKey_ClaimEntity',
  ClaimantId = 'RelatedEntityKey_Claimant',
  TaskId = 'RelatedEntityKey_TaskEntity',
  BeneficiaryId = 'RelatedEntityKey_Beneficiary',
  InsuredId = 'RelatedEntityKey_Insured',
  ContactId = 'RelatedEntityKey_Contact',
  DocumentId = 'RelatedEntityKey_DocumentEntity',
  PaymentId = 'RelatedEntityKey_Payment',
}
